import { useEffect, useState } from 'react';
import { Clock, ShieldAlert } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import { getTimeUntilMaintenanceEnd } from '../../lib/maintenanceUtils';
import { useEmbedStore } from '../../lib/embedStore';
import { useLeagueMode } from '../../lib/hooks/useLeagueMode';
import { useMaintenanceMode } from '../../lib/hooks/useMaintenanceMode';
import './EmbedBuildMaintenancePage.css';

const ARSENAL_FONTS_ID = 'arsenal-sports-fonts';
const ARSENAL_FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Anton&family=Open+Sans:wght@400;600;700;800&display=swap';

function useArsenalFonts() {
  useEffect(() => {
    if (document.getElementById(ARSENAL_FONTS_ID)) return;
    const link = document.createElement('link');
    link.id = ARSENAL_FONTS_ID;
    link.rel = 'stylesheet';
    link.href = ARSENAL_FONTS_HREF;
    document.head.appendChild(link);
  }, []);
}

export function EmbedBuildMaintenancePage() {
  const isEmbed = useEmbedStore((state) => state.isEmbed);
  const { isBuildPhase, isLoading: modeLoading } = useLeagueMode();
  const { isMaintenance, isLoading: maintenanceLoading } = useMaintenanceMode();
  const [timeRemaining, setTimeRemaining] = useState(() => getTimeUntilMaintenanceEnd());

  useArsenalFonts();

  useEffect(() => {
    const interval = window.setInterval(() => {
      setTimeRemaining(getTimeUntilMaintenanceEnd());
    }, 60_000);

    return () => window.clearInterval(interval);
  }, []);

  if (modeLoading || maintenanceLoading) {
    return (
      <div className="embed-build-maintenance" aria-busy="true">
        <div className="embed-build-maintenance__panel embed-build-maintenance__panel--loading">
          <span className="spinner-border" role="status" aria-label="Chargement" />
        </div>
      </div>
    );
  }

  if (!isEmbed) {
    return <Navigate to="/standings" replace />;
  }

  if (!isMaintenance) {
    return <Navigate to={isBuildPhase ? '/build-my-team' : '/my-office'} replace />;
  }

  if (!isBuildPhase) {
    return <Navigate to="/standings" replace />;
  }

  return (
    <section className="embed-build-maintenance" aria-labelledby="embed-build-maintenance-title">
      <div className="embed-build-maintenance__panel">
        <div className="embed-build-maintenance__eyebrow">
          <ShieldAlert size={18} aria-hidden="true" />
          Maintenance
        </div>

        <h1 id="embed-build-maintenance-title">On le sait, tu veux batir la prochaine dynasty.</h1>

        <p className="embed-build-maintenance__lead">
          Mais la construction d'équipe est mise en pause pendant la maintenance des données.
        </p>

        <div className="embed-build-maintenance__notice" role="status">
          <Clock size={22} aria-hidden="true" />
          <div>
            <strong>Retour prévu à 5 h AM</strong>
            <span>Heure de Montréal. Temps restant estimé : {timeRemaining}.</span>
          </div>
        </div>

        <p className="embed-build-maintenance__fineprint">
          Les clubs déjà complétés gardent accès aux stats live. Dès la fin de la maintenance, tu pourras revenir bâtir ton équipe et finaliser ton club.  Refresh la page si on a passer 5h am
        </p>
      </div>
    </section>
  );
}